<!-- <form [formGroup]="productForm" (ngSubmit)="onSubmit()" (keydown.enter)="onEnterForAddUpdate($event)"> -->
<form [formGroup]="productForm" (keydown.enter)="onEnterForAddUpdate($event)">
    <div class="row mb-2">
        <div class="col-md-3 pad-80 pad-right-30">
            <div class="row mb-2">
                <div class="col-md-12 col-xl-8 col-lg-8 col-xxl-8">
                    <app-master-file-upload #fileUpload (productfileChanged)="onFilesChanged($event)"
                        [allowedFileTypes]="allowedFileTypeExtensions"
                        [srcFileComponent]="srcFileComponent"></app-master-file-upload>


                </div>
                <div class="col-md-4 col-xl-4 col-lg-4 col-xxl-4 align-self-center">
                    <button type="button" class="btn btn-outline-dark me-2" title="Upload Product's"
                        [disabled]="!fileToUpload" (click)="productBulkUpload()">
                        <i class="fa-solid fa-upload"></i>
                    </button>

                    <button type="button" class="btn btn-outline-dark" title="Download Sample Excel"
                        (click)="downloadSampleExcel()">
                        <i class="fa-solid fa-download"></i>
                    </button>
                </div>
            </div>
            <div class="row mb-2">
                <div class="col-md-8 col-xl-8 col-lg-8 col-xxl-7">
                    <label _ngcontent-ng-c2981618652="" class="fw-bold text-dark mb-2 mt-3">AVAILABLE CATEGORIES</label>
                    <div class="table-responsive prodtableFixHead">
                        <table class="table datatable border-x-0 mb-0">
                            <tbody>
                                <tr *ngFor="let category of categoriesList">
                                    <td class="table-row">{{category.categoryName}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-9 pad-80">
            <div class="row">
                <div class="col-md-6">
                    <label class="fw-bold text-dark mb-0">EDIT
                        EXISTING</label> : PRODUCT
                </div>
                <div class="col-md-5   position-relative">
                    <input type="text" class="form-control" placeholder="SEARCH BY DESCRIPTION, UPC OR ITEM#"
                        formControlName="searchControl" (keydown.enter)="onEnterForSearch($event)">
                    <img src="assets/images/magnifying-glass.png" placeholder="Type Project Title to Filter"
                        class="searchIcon" alt="" (click)="searchClicked()">
                </div>
                <div class="col-md-1 align-self-center text-center">
                    <div class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle urserName" href="#" role="button" data-bs-toggle="dropdown"
                            aria-expanded="true">
                            <img src="assets/images/filter.png" class="me-0 w-20" alt="" title="Filter">
                        </a>
                        <ul class="dropdown-menu customMargindrp" data-popper-placement="bottom-end"
                            style="position: absolute; inset: 0px 0px auto auto; margin: 0px; transform: translate3d(0.8px, 24.8px, 0px);">

                            <div class="row mb-12px">
                                <div class="col-md-5">
                                    <label>Category</label>
                                </div>
                                <div class="col-md-7">
                                    <select class="form-select border-0" aria-label="Default select example"
                                        formControlName="categoryIDFilter">
                                        <option value="0">Select Category</option>
                                        <option *ngFor="let item of categoriesList" [value]="item.categoryID">
                                            {{item.categoryName}}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div class="row mb-12px">
                                <div class="col-md-5">
                                    <label>Product Status</label>
                                </div>
                                <div class="col-md-7">
                                    <select class="form-select border-0" aria-label="Default select example"
                                        formControlName="isActiveFilter">
                                        <option *ngFor="let item of isActiveOptions" [value]="item.value">{{item.label}}
                                        </option>
                                    </select>
                                    <!-- <input type="checkbox" formControlName="isActiveFilter" > -->
                                    <!-- <div class="activeDesablebtn alignitemss">
                                        <div class="toggle-button-cover">
                                            <div class="button-cover">
                                                <div class="button b2"
                                                    id="button-14">
                                                    <input type="checkbox" class="checkbox" 
                                                        [checked]="true" formControlName="isActiveFilter">
                                                    <div class="knobs">
                                                        <span></span>
                                                    </div>
                                                    <div class="layer"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div> -->
                                </div>
                            </div>

                            <div class="row mb-12px">
                                <div class="col-md-5">
                                    <label>Product Verified</label>
                                </div>
                                <div class="col-md-7">
                                    <select class="form-select border-0" aria-label="Default select example"
                                        formControlName="isVerifiedFilter">
                                        <option *ngFor="let item of isActiveOptions" [value]="item.value">{{item.label}}
                                        </option>
                                    </select>
                                    <!-- <input type="checkbox" formControlName="isVerifiedFilter"> -->
                                </div>
                            </div>


                            <div class="row ">
                                <div class="offset-md-3 col-md-9">
                                    <button type="button" (click)="onApplyFilter(true);"
                                        class="btn progressBtn ps-2 w-100">APPLY
                                        FILTER</button>
                                </div>
                            </div>


                        </ul>
                    </div>
                </div>
            </div>

            <div class="table-responsive tableFixHead mt-3" (scroll)="onScroll()">
                <table class="table datatable border-x-0 mb-0">
                    <thead>
                        <tr class="subheaderrr">

                            <th scope="col" class="text-start py-2">Category</th>
                            <th scope="col" class="text-start py-2">Product Title</th>
                            <th scope="col" class="text-start py-2">UPC</th>
                            <th scope="col" class="text-start py-2">Item #</th>
                            <th scope="col" class="text-start py-2">Parent</th>
                            <th scope="col" class="text-start py-2">
                                Is Active</th>
                            <th scope="col" class="text-start py-2">
                                Is Verified</th>
                            <!-- <th scope="col" class="text-start py-2 border-end-0" width="8%">
                                ACTION</th> -->

                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of filteredProducts">

                            <td class="vertical-align-middle">
                                {{item.categoryName}}
                            </td>
                            <td class="vertical-align-middle">
                                {{item.productTitle}}
                            </td>
                            <td class="vertical-align-middle">
                                {{item.upc}}
                            </td>
                            <td class="vertical-align-middle">
                                {{item.vendorItemNumber}}
                            </td>
                            <td class="vertical-align-middle">
                                {{item.parentProduct}}
                            </td>
                            <td>
                                <div class="activeDesablebtn alignitemss">
                                    <div class="toggle-button-cover">
                                        <div class="button-cover">
                                            <div class="button b2" id="button-14">
                                                <!-- <input type="checkbox" class="checkbox" [checked]="item.isActive"> -->
                                                <input type="checkbox" class="checkbox" [checked]="item.isActive"
                                                    (change)="enableOrDisableProduct($event, item)">
                                                <div class="knobs">
                                                    <span></span>
                                                </div>
                                                <div class="layer"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="activeDesablebtn alignitemss">
                                    <div class="toggle-button-cover">
                                        <div class="button-cover">
                                            <div class="button b2" id="button-14">
                                                <!-- <input type="checkbox" class="checkbox" [checked]="item.isVerified">     -->
                                                <input type="checkbox" class="checkbox" [checked]="item.isVerified"
                                                    (change)="verifyProduct($event, item)">
                                                <div class="knobs">
                                                    <span></span>
                                                </div>
                                                <div class="layer"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <!-- <td class="vertical-align-middle text-center">
                                <img src="assets/images/pencilIocn.svg" (click)="editProduct(item.productID!);"
                                    title="Edit" alt="" style="cursor: pointer;">
                            </td> -->
                        </tr>

                        <!-- <tr>
        
                            <td class="vertical-align-middle">
                                Baby Care
                            </td>
                            <td class="vertical-align-middle">
                                Product Title
                            </td>
                            <td class="vertical-align-middle">
                                3947394747
                            </td>
                            <td class="vertical-align-middle"></td>
                            <td class="vertical-align-middle"></td>
                            <td>
                                <div class="activeDesablebtn alignitemss">
                                    <div class="toggle-button-cover">
                                        <div class="button-cover">
                                            <div class="button b2"
                                                id="button-14">
                                                <input type="checkbox"
                                                    class="checkbox">
                                                <div class="knobs">
                                                    <span></span>
                                                </div>
                                                <div class="layer"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td class="vertical-align-middle text-center">
                                <img src="assets/images/pencilIocn.svg"
                                    title="Edit" alt="" style="cursor: pointer;">
                            </td>
                        </tr> -->

                        <!-- <tr>
        
                            <td class="vertical-align-middle">
                                Baby Care
                            </td>
                            <td class="vertical-align-middle">
                                Product Title
                            </td>
                            <td class="vertical-align-middle">
                                3947394747
                            </td>
                            <td class="vertical-align-middle"></td>
                            <td class="vertical-align-middle"></td>
                            <td>
                                <div class="activeDesablebtn alignitemss">
                                    <div class="toggle-button-cover">
                                        <div class="button-cover">
                                            <div class="button b2"
                                                id="button-14">
                                                <input type="checkbox"
                                                    class="checkbox" checked>
                                                <div class="knobs">
                                                    <span></span>
                                                </div>
                                                <div class="layer"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td class="vertical-align-middle text-center">
                                <img src="images/pencilIocn.svg"
                                    title="Edit" alt="" style="cursor: pointer;">
                            </td>
                        </tr> -->
                    </tbody>
                </table>
                <div class="card" *ngIf="filteredProducts.length === 0 ">
                    <div class="card-body py-2 px-3">
                        <div class="emtyCard p-0">
                            <p class="mb-0">No Records Found
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</form>